"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildOptionArray = exports.buildOptionsArrayWithLabels = exports.onChange = exports.mapCommonFieldProperties = exports.mapCommonFieldPropertiesFromObject = exports.enhance = exports.attachBooleanComponentToFormLoadableRender = exports.attachComponentToFormLoadableRender = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Validations = _interopRequireDefault(require("../../Validations"));

var _StringHelper = require("../../Utilities/StringHelper");

var _propTypes = _interopRequireDefault(require("prop-types"));

var attachComponentToFormLoadableRender = function attachComponentToFormLoadableRender(loaded, props) {
  // This line was disabled in eslint because we don't want to include attachComponentToForm on every Component that
  // is utilized in FormBuilder because it is a FormBuilder specific prop.
  var attachComponentToForm = props.attachComponentToForm,
      others = (0, _objectWithoutProperties2.default)(props, ["attachComponentToForm"]);
  var Component = loaded;

  var ref = /*#__PURE__*/_react.default.createRef();

  attachComponentToForm === null || attachComponentToForm === void 0 ? void 0 : attachComponentToForm(ref);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, others, {
    ref: ref
  }));
};

exports.attachComponentToFormLoadableRender = attachComponentToFormLoadableRender;
attachComponentToFormLoadableRender.propTypes = {
  attachComponentToForm: _propTypes.default.func
};

var attachBooleanComponentToFormLoadableRender = function attachBooleanComponentToFormLoadableRender(loaded, props) {
  // This line was disabled in eslint because we don't want to include attachComponentToForm on every Component that
  // is utilized in FormBuilder because it is a FormBuilder specific prop.
  var attachComponentToForm = props.attachComponentToForm,
      value = props.value,
      others = (0, _objectWithoutProperties2.default)(props, ["attachComponentToForm", "value"]);
  var Component = loaded;

  var ref = /*#__PURE__*/_react.default.createRef();

  attachComponentToForm === null || attachComponentToForm === void 0 ? void 0 : attachComponentToForm(ref);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    value: value,
    checked: value
  }, others, {
    ref: ref
  }));
};

exports.attachBooleanComponentToFormLoadableRender = attachBooleanComponentToFormLoadableRender;
attachBooleanComponentToFormLoadableRender.propTypes = {
  attachComponentToForm: _propTypes.default.func
};

var enhance = function enhance(component) {
  return (0, _Validations.default)(component.default);
};

exports.enhance = enhance;

var mapCommonFieldPropertiesFromObject = function mapCommonFieldPropertiesFromObject(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onValidation = _ref.onValidation;
  return mapCommonFieldProperties(field, htmlId, value, onBlur, onValidation);
};

exports.mapCommonFieldPropertiesFromObject = mapCommonFieldPropertiesFromObject;

var mapCommonFieldProperties = function mapCommonFieldProperties(field, htmlId, value, onBlur, onValidation) {
  var _ref2, _field$properties$hin;

  return {
    component: undefined,
    id: htmlId,
    value: (_ref2 = value !== null && value !== void 0 ? value : field.value) !== null && _ref2 !== void 0 ? _ref2 : "",
    disabled: field.isDisabled,
    helperText: (_field$properties$hin = field.properties.hints) !== null && _field$properties$hin !== void 0 ? _field$properties$hin : undefined,
    placeholder: field.properties.placeholder,
    required: field.properties.isRequired,
    label: field.properties.label ? field.properties.label : field.label || field.name,
    fullWidth: true,
    onBlur: onBlur,
    onChange: onChange,
    onValidation: onValidation
  };
};

exports.mapCommonFieldProperties = mapCommonFieldProperties;

var onChange = function onChange(params) {
  var event = params[0];
  var value = params[1];
  var newValue = value;

  if (!newValue) {
    newValue = event.target.value;
  }

  return {
    value: newValue
  };
};

exports.onChange = onChange;

var buildOptionsArrayWithLabels = function buildOptionsArrayWithLabels(allowedValues) {
  return allowedValues.map(function (value) {
    var innerValue = value.value;
    var label = value.label;

    if ((0, _StringHelper.isNullOrWhiteSpace)(label)) {
      throw new Error("'allowedValues' prop contains an invalid 'label': ".concat(label));
    }

    return {
      value: innerValue,
      label: label
    };
  });
};

exports.buildOptionsArrayWithLabels = buildOptionsArrayWithLabels;

var buildOptionArray = function buildOptionArray(allowedValues) {
  return allowedValues.map(function (value) {
    return {
      value: value,
      label: value.toString()
    };
  });
};

exports.buildOptionArray = buildOptionArray;
var _default = mapCommonFieldProperties;
exports.default = _default;